import { HomesLink } from 'src/Components/Navigation'
import HomesContainer from './HomesContainer'

export default HomesContainer(HomesLink)
